/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Execute/schedule immediately on enrollment (first step) or
 * immediately after the previous step completes.
 */
export const StepScheduleImmediateValue = {
  mode: 'immediate',
} as const;
export type StepScheduleImmediate = typeof StepScheduleImmediateValue;
